/**
 * HTML boot splash helpers for store PWA cold starts.
 * Kept on window by public/index.html; React coordinates when to dismiss.
 */

export function isBootSplashActive() {
  return typeof window !== 'undefined' && Boolean(window.__FL_BOOT_SPLASH_ACTIVE);
}

export function hideBootSplash() {
  if (typeof window === 'undefined') return;
  if (typeof window.__FL_HIDE_BOOT_SPLASH === 'function') {
    window.__FL_HIDE_BOOT_SPLASH();
  }
}

/**
 * Bind splash branding to the current URL slug only.
 * If that store has no cached branding → neutral spinner (no previous store logo).
 */
export function applyStoreBootBranding(slug) {
  if (typeof window === 'undefined' || !slug) return;
  window.__FL_STORE_SLUG = slug;
  if (typeof window.__FL_APPLY_STORE_BRANDING === 'function') {
    window.__FL_APPLY_STORE_BRANDING(slug);
  }
}

/**
 * Call when the first meaningful store route content is ready to paint.
 * Safe to call multiple times.
 */
export function revealStoreUI() {
  hideBootSplash();
}
